import React, { createContext, useContext } from "react";
import useCartState from "features/market/hooks/useCartState";

const CartContext = createContext(null);

/**
 * CartProvider - Manages shopping cart state, persistence, and disclosure state.
 * Cart item transitions are delegated to `src/domain/market/cart.js`.
 * @param {Object} props
 * @param {React.ReactNode} props.children
 */
export const CartProvider = ({ children }) => {
  const value = useCartState();

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
};

/**
 * Custom hook to use cart context
 * @returns {Object} Cart context value
 * @throws {Error} If used outside CartProvider
 */
export const useCart = () => {
  const context = useContext(CartContext);

  if (!context) {
    throw new Error("useCart must be used within a CartProvider");
  }

  return context;
};

export default CartContext;
